import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import ContentContainer from '@piconetworks/content-container'
import Image from '@piconetworks/image'
import { getSvgImage } from '@piconetworks/functions'

import style from './Overlay.module.scss'

class Overlay extends React.Component {
    closeHeader = () => {
        const {
            showLauncher,
        } = this.props

        showLauncher()
    }

    render() {
        const {
            children,
            contrastColor,
            linkColor,
            coverPhoto,
        } = this.props

        const headerStyle = {
            backgroundColor: linkColor,
            color: contrastColor,
        }

        return (
            <div className={style.overlay}>
                <ContentContainer className={style.contentContainer}>
                    <button className={style.closeButton} type="button" onClick={this.closeHeader}>
                        {getSvgImage(linkColor, 'close-icon')}
                    </button>
                    <div className={classNames(style.modalTopBorder)} style={headerStyle} />
                    <Image.CoverPhoto
                        className={classNames(style.banner)}
                        style={{ backgroundImage: `url(${coverPhoto})` }}
                    />
                    {children}
                </ContentContainer>
            </div>
        )
    }
}

Overlay.defaultProps = {
    children: null,
    showLauncher: null,
    contrastColor: null,
    linkColor: null,
    coverPhoto: null,
}

Overlay.propTypes = {
    children: PropTypes.node,
    showLauncher: PropTypes.func,
    contrastColor: PropTypes.string,
    linkColor: PropTypes.string,
    coverPhoto: PropTypes.string,
}

export default Overlay
